// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActionButtons_wrapper__KfBMh","button":"ActionButtons_button__BhCx2"};